import styled, { css } from 'styled-components'
import posed from 'react-pose'

export const StyledCard = styled.div`
    margin-left: 2.5px;
    margin-right: 2.5px;
    margin-bottom: 5px;
    padding: ${({ smallPadding }) => smallPadding ? '15px' : '25px'};
    background-color: ${({ theme }) => theme.whiteTwo};
    border-radius: 4px;
    width: calc(100% - 5px);
    ${({ urgent }) =>
        urgent &&
        css`
        border: 2px solid ${({ theme }) => theme.pastelRed50};
    `};
    position: relative;
`

export const StyledCardHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${({ centered }) => centered ? 'center' : 'space-between'};
    margin-bottom: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    letter-spacing: 0.5px;
`

export const StyledCardItem = styled.div`
    display: flex;
    justify-content: ${({ centered }) => centered ? 'center' : 'space-between'};
    align-items: center;
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
`

export const StyledCardItemLeft = styled.div``

export const StyledCardItemRight = styled.div`
    margin-left: 30px;
`

export const StyledCardItemName = styled.div`
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 5px;
`

export const StyledCardItemValue = styled.div`
    font-size: 15px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    letter-spacing: 0.5px;
    color: ${({ theme, active }) => active ? theme.grassyGreen : theme.brownGrey};
`

export const StyledCardActivity = styled.div`
    width: 100%;
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
    ${({ noMargin }) =>
        noMargin &&
        css`
        margin: 0;
    `}
`

export const StyledCardActivityTitle = styled.div`
    width: 100%;
    font-size: 16px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 5px;
`

export const StyledCardActivityValues = styled.div`
    width: 100%;
    display: flex;
`;

export const StyledCardDrawer = styled.div`
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
`

export const StyledCardDrawerWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`

export const StyledCardDrawerLeft = styled.div``

const StyledCardDrawerRightPosed = posed.div({
    visible: {
        transform: 'scale(1)',
        opacity: 1
    },
    hidden: {
        transform: 'scale(0)',
        opacity: 0
    }
})

export const StyledCardDrawerRight = styled(StyledCardDrawerRightPosed)`
    margin-left: 30px;
    transform-origin: center center;
`

const StyledCardDrawerContentPosed = posed.div({
    visible: {
        height: '100%',
    },
    hidden: {
        height: '0',
        overflow: 'hidden'
    }
});

export const StyledCardDrawerContent = styled(StyledCardDrawerContentPosed)`

`
export const StyledCardList = styled.ul`
    padding: 0;
    list-style-type: none;
`
export const StyledCardSection = styled.div`
    margin-bottom: 16px;
`